import { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { useHistory } from "react-router"
import BottomBar from "../BottomBar/bottombar"
import {
  demoMapSmall,
  alertWarning,
  phoneCall,
  demoMapLarge,
  Maximize,
  Minimize
} from "images"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import { RootState } from "store/store"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import { useTranslation } from "react-i18next"

export type facility = { street: string; city: string; state: string }

const useStyles = makeStyles(() => ({
  warningContainer: {
    backgroundColor: "rgba(218, 30, 40, 0.15)",
    height: "158px",
    minWidth: "375px",
    width: "67%",
    display: "flex",
    padding: "16px"
  },
  warningIcon: {
    width: "64px",
    float: "left"
  },
  warningText: {
    minWidth: "257px",
    float: "left",
    paddingLeft: "16px"
  },
  warningMsg: {
    fontSize: "16px",
    fontFamily: "Lato",
    color: "#21252A",
    lineHeight: "24px",
    margin: "0",
    marginTop: "12px"
  },
  headingTitle: {
    fontSize: "18px",
    fontFamily: "Lato",
    color: "#21252A",
    fontWeight: "bold",
    margin: "0"
  },
  shippingInfo: {
    minWidth: "375px",
    width: "67%",
    padding: "0 16px 24px 16px",
    color: "#21252A",
    letterSpacing: 0,
    fontFamily: "Lato",
    fontSize: "16px",
    lineHeight: "24px",
    borderBottom: "1px solid #DEE2E6"
  },
  paddingTop16: {
    paddingTop: "16px"
  },
  labelHeading: {
    color: "#495057",
    display: "block"
  },
  callBtn: {
    border: "2px solid #0E65E5",
    borderRadius: "4px",
    textAlign: "center",
    fontWeight: "bold",
    color: "#0E65E5",
    fontFamily: "Lato",
    fontSize: "16px",
    letterSpacing: "0.4px",
    lineHeight: "24px",
    width: "100%",
    verticalAlign: "middle",
    padding: "12px 0",
    background: "#fff",
    cursor: "pointer",
    display: "block",
    textDecoration: "none"
  },
  callBtnTxt: {
    cursor: "pointer",
    paddingLeft: "15px"
  },
  mapContainerSmall: {
    height: "292px",
    minWidth: "375px",
    width: "67%",
    padding: "8px 16px 16px 16px",
    position: "relative"
  },
  mapImage: {
    width: "100%",
    maxWidth: "100%",
    position: "relative"
  },
  mapContainerLarge: {
    height: "100%",
    minWidth: "375px",
    width: "67%",
    position: "relative"
  },
  fullScreenIcon: {
    cursor: "pointer",
    position: "absolute",
    top: "4px",
    right: "12px"
  },
  fullScreenIconLarge: {
    cursor: "pointer",
    position: "absolute",
    top: "0px",
    right: "-3px"
  }
}))

export default function ShippingInfo() {
  const { t } = useTranslation()
  const classes = useStyles()
  const history: any = useHistory()
  const location = useSelector(
    (state: RootState) => state.locationReducer.location
  )
  const locationData = history.location.state?.data || ""

  const facilityId = useSelector(
    (state: RootState) => state.facilityReducer.facility?.id || ""
  )

  const [address, setAddress] = useState({} as facility)
  const [contact, setContact] = useState("")
  const [fullScreenView, setFullScreenView] = useState(false)

  useEffect(() => {
    http
      .get(`${apiEndPoints.facilities}/${facilityId}`)
      .then(response => {
        const { data } = response.data
        setAddress(data?.address || "")
        setContact(data?.configuration?.phone || "")
      })
      .catch(err => {
        toast.error(err.response.data.error)
        history.push(location)
      })
    // eslint-disable-next-line
  }, [])

  const backToPreviousPage = () => history.go(-1)

  const fullScreenClick = () => setFullScreenView(!fullScreenView)

  return (
    <>
      <div className="container">
        {!fullScreenView && (
          <>
            <div className={classes.warningContainer}>
              <div className={classes.warningIcon}>
                <img src={alertWarning} alt="warning" />
              </div>
              <div className={classes.warningText}>
                <p className={classes.headingTitle}>{t("what_to_do_next")}</p>
                {locationData === "referenceNumber" && (
                  <p className={classes.warningMsg}>
                    {t("incorrect_load_number")}
                  </p>
                )}
                {locationData !== "referenceNumber" && (
                  <p className={classes.warningMsg}>
                    {t("contact_shipping_issues")}
                  </p>
                )}
              </div>
            </div>
            <div className={classes.shippingInfo}>
              <p className={classes.headingTitle}>
                {t("shipping_office_details")}
              </p>
              <div className={classes.paddingTop16}>
                <label className={classes.labelHeading}>{t("address")}</label>
                <label>
                  {address.street}, {address.city}, {address.state}
                </label>
              </div>
              {contact != "" && (
                <>
                  <div className={classes.paddingTop16}>
                    <label className={classes.labelHeading}>
                      {t("contact")}
                    </label>
                    <label>{contact}</label>
                  </div>
                  <div className={classes.paddingTop16}>
                    <a className={classes.callBtn} href={`tel:${contact}`}>
                      <img
                        className="vert-middle"
                        src={phoneCall}
                        alt="phoneCall"
                      />
                      <label className={classes.callBtnTxt}>
                        {t("call_shipping_office")}
                      </label>
                    </a>
                  </div>
                </>
              )}
            </div>
          </>
        )}
        <div
          className={
            fullScreenView
              ? classes.mapContainerLarge
              : classes.mapContainerSmall
          }
        >
          <img
            src={fullScreenView ? demoMapLarge : demoMapSmall}
            alt={fullScreenView ? "demoMapLarge" : "demoMapSmall"}
            className={classes.mapImage}
          />
          <img
            src={fullScreenView ? Minimize : Maximize}
            alt={fullScreenView ? "Minimize" : "Maximize"}
            className={
              fullScreenView
                ? classes.fullScreenIconLarge
                : classes.fullScreenIcon
            }
            onClick={fullScreenClick}
          />
        </div>
      </div>
      <BottomBar
        onClick={backToPreviousPage}
        text={t("back_to_fast_track")}
        startIcon={<KeyboardArrowLeftIcon />}
      />
    </>
  )
}
